<template>
    <div>
        <div class="container">
            <nav aria-label="breadcrumb">
                <ol class="breadcrumb">
                    <router-link :to="{ name: 'PCReDive' }" tag="li" class="breadcrumb-item">
                        <a href="#">首頁</a>
                    </router-link>
                    <router-link :to="{ name: 'Equipment' }" tag="li" class="breadcrumb-item">
                        <a href="#">Ex 裝備列表</a>
                    </router-link>
                </ol>
            </nav>
            <div class="item-box">
                <div class="row">
                    <div class="col-lg-12 col-md-12 col-12">
                        <h3 class="item-title">
                            {{ $t("FilterFunction") }}
                        </h3>                        
                        <!-- <div class="row p-3">
							<input
								type="text"
								class="form-control search-btn"
								placeholder="輸入裝備名稱搜尋"
								aria-label="Search for..."
								v-on:input="debounceInput"
							/>
						</div> -->
                        <div class="row mb-3">
                            <div class="col-12">
                                <template>
                                    <button
                                        class="pcbtn m-1"
                                        v-for="item in categoryList"
                                        @click="setFilterType(item.category)"
                                        :class="item.category == filterType ? 'active' : ''"
                                    >
                                        {{ getI18nName(item, "category_name") }}
                                        <span :class="'icon-ex inline in_button ex' + item.category"></span>
                                    </button>
                                </template>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12 mb-3">
                        <h3 class="item-title">
                            {{ $t("UnitExEquipmentList") }}
                        </h3>
                        <div class="d-flex flex-wrap">
                            <div class="m-2 jjustify-content-lg-start justify-content-center" v-for="item in exEqUnitList">
                                <template>
                                    <router-link :to="{ name: 'CharacterDetail', params: { id: item.unit_name } }">
                                        <img
                                            class="sm-w70"
                                            v-lazy="'/static/images/unit/icon_unit_' + (Number(item.unit_id) + 30) + '.png'"
                                            width="80"
                                            alt=""
                                        />
                                    </router-link>
                                </template>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <h3 class="item-title">
                            {{ $t("EquipmentList") }}
                        </h3>
                        <div class="skill-box ex-prod-wrap my-3" v-for="(item, key) in filterData">
                            <div class="row">
                                <div class="col-lg-2 col-12">
                                    <div class="skill-img d-flex justify-content-center align-items-center">                                        
                                        <img
                                            class="img-fluid"
                                            width="85"
                                            v-lazy="'/static/images/equipment/icon_equipment_' + item.ex_equipment_id + '.png'"
                                            :alt="getI18nName(item, 'name')"
                                            :title="getI18nName(item, 'name')"
                                        />
                                    </div>
                                </div>
                                <div class="col-lg-5 col-12">
                                    <div class="skill-description">
                                        <div class="skill-type mb-1" :style="eqStyle(item)">{{ eqTitle(item) }} ★{{ item.rarity }}</div>
                                        <h3 class="skill-name">{{ getI18nName(item, "name").replace("【クラン】", "") }}</h3>
                                        {{ replaceDescription(getI18nName(item, "description")) }}
                                    </div>
                                </div>
                                <div class="col-lg-5 col-12">
                                    <div class="skill-effect">
                                        <!-- {{item}} -->
                                        {{ getSkillDescription(item) }}                                        
                                    </div>
                                </div>
                            </div>
                            <div class="prod-info-box mt-3 ex-prod">
                                <div class="uq-title mb-3 pb-1 d-block">
                                    <div class="eqLevel-box">{{ $t("EquimentStatus") }} ±0.03%</div>
                                </div>
                                <div class="row">
                                    <div class="col-12 mb-3" v-if="Number(item.default_hp) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                HP
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'hp')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_life_steal) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("life_steal") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'life_steal')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_wave_hp_recovery) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("wave_hp_recovery") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'wave_hp_recovery')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_wave_energy_recovery) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("wave_energy_recovery") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'wave_energy_recovery')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_energy_recovery_rate) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("energy_recovery_rate") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'energy_recovery_rate')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_energy_reduce_rate) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("energy_reduce_rate") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'energy_reduce_rate')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_atk) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("atk") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'atk')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_magic_str) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("magic_str") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'magic_str')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_accuracy) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("accuracy") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'accuracy')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_def) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("def") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'def')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_magic_def) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("magic_def") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'magic_def')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_dodge) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("dodge") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'dodge')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_physical_critical) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("physical_critical") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'physical_critical')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_magic_critical) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("magic_critical") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'magic_critical')"></span>
                                        </div>
                                    </div>
                                    <div class="col-12 mb-3" v-if="Number(item.default_hp_recovery_rate) > 0">
                                        <div class="prod-data d-flex">
                                            <span class="title">
                                                {{ $t("hp_recovery_rate") }}
                                            </span>
                                            <span class="prod-value" v-html="eqStatus(item, 'hp_recovery_rate')"></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import ex_equipment_data from "../assets/edata/ex_equipment_data.txt";
import ex_equipment_category from "../assets/edata/ex_equipment_category.txt";
import unit_ex_equipment_slot from "../assets/edata/unit_ex_equipment_slot.txt";
import skill_data from "../assets/edata/skill_data.txt";
export default {
    name: "ExEquipment",
    data() {
        return {
            filter: "",
            filterType: "101",
            step: 1,
            exEquipmentData: {},
            exEquipmentCategory: {},
            unitExEquipmentSlot: {},
        };
    },
    metaInfo: {
        // if no subcomponents specify a metaInfo.title, this title will be used
        title: "Ex 裝備列表",
        // all titles will be injected into this template
        titleTemplate: "%s | 蘭德索爾圖書館 公主連結 Wiki",
        meta: [{ charset: "utf-8" }, { name: "description", content: "超異域公主連結☆Re:Dive 的Ex 裝備列表" }],
    },
    methods: {
        getStarNumber: function(rarity) {
            let nRarity = Number(rarity);
            if (nRarity >= 4) {
                return 5;
            } else if (nRarity < 4 && nRarity >= 2) {
                return 4;
            } else {
                return 3;
            }
        },
        setFilterType: function(type) {
            this.filterType = type;
            this.filter = "";
        },
        eqTitle: function(item) {
            let title = "";
            var obj = _.find(this.exEquipmentCategory, ["category", item.category]);
            let objName = this.getI18nName(obj, "category_name");
            title += objName;
            if (item.clan_battle_equip_flag == "1") {
                title += " [" + this.$t("Clan") + "]";
            } else {
                title += " EX";
            }
            return title;
        },
        eqStyle: function(item) {
            var obj = _.find(this.exEquipmentCategory, ["category", item.category]);
            return "background: " + obj.outline;
        },
        eqStatus: function(item, attributeName) {
            let status = "";
            let defaultNumber = Number(item["default_" + attributeName]) * 0.01;
            let maxNumber = Number(item["max_" + attributeName]) * 0.01;
            function getStar(star) {
                let box;
                switch (Number(star)) {
                    case 6:
                        box = `<span style="color:#6ab6f7">♦♦♦</span><span style="color:#e58dcd">♦♦</span>`;
                        return box;
                    case 5:
                        box = `<span style="color:#6ab6f7">♦♦♦</span><span style="color:#e58dcd">♦</span>`;
                        return box;
                    case 4:
                        box = `<span style="color:#6ab6f7">♦♦♦</span>`;
                        return box;
                    case 3:
                        box = `<span style="color:#6ab6f7">♦♦♢</span>`;
                        return box;
                    case 2:
                        box = `<span style="color:#6ab6f7">♦♢♢</span>`;
                        return box;
                    case 1:
                        box = `<span style="color:#6ab6f7">♢♢♢</span>`;
                        return box;
                        break;
                    default:
                        return "";
                }
            }

            function getStarBox(inbox, n) {
                let starNumber = defaultNumber * Number(n) > maxNumber ? maxNumber : (defaultNumber * Number(n)).toFixed(2);
                let box = `<span class="ex-star-box">${inbox} <span class="ex-star-value d-inline-block">${starNumber}</span> %</span>`;
                return box;
            }
            if (item.clan_battle_equip_flag == "1") {
                switch (item.rarity) {
                    case "3":                    
                        for (let starN = 1; starN <= 6; starN++) {
                            status += getStarBox(getStar(starN), starN);
                        }
                        return status;
                        break;
                    case "2":
                        for (let starN = 1; starN <= 5; starN++) {
                            status += getStarBox(getStar(starN), starN);
                        }
                        return status;
                        break;
                    default:
                        break;
                }
            } else {
                switch (item.rarity) {
                    case "4":
                        let maxStart = 6
                        if(item.is_force_protected == "1") {
                            maxStart = 4
                        }
                        for (let starN = 1; starN <= maxStart; starN++) {
                            status += getStarBox(getStar(starN), starN);
                        }
                        return status;
                        break;
                    case "3":
                        for (let starN = 1; starN <= 6; starN++) {
                            status += getStarBox(getStar(starN), starN);
                        }
                        return status;
                        break;
                    case "2":
                        for (let starN = 1; starN <= 5; starN++) {
                            status += getStarBox(getStar(starN), starN);
                        }
                        return status;
                        break;
                    case "1":
                        for (let starN = 1; starN <= 4; starN++) {
                            status += getStarBox(getStar(starN), starN);
                        }
                        return status;
                        break;
                    default:
                        break;
                }
            }
            this.$forceUpdate();
            //return `♦0 ${defaultNumber}% ♦5 ${maxNumber}%`;
        },
        getI18nName: function(item, name) {
            switch (this.locale) {
                case "en":
                    return item["en_" + name];
                    break;
                case "jp":
                    return item["jp_" + name];
                    break;
                default:
                    return item[name];
                    break;
            }
        },
        setLevel: function(level) {
            this.step = level;
        },
        levelStyle: function(n) {
            let level = this.step;
            if (level < 4 && n < 4) {
                return "color: #6ab6f7";
            }
            if (n <= 6 && n >= 4 && level <= 6 && level >= 4) {
                return "color: #e58dcd";
            }
        },
        replaceDescription: function(stringDesc) {
            return _.replace(stringDesc, new RegExp("\\\\n", "g"), " ");
        },
        getSkillDescription: function(item) {
            var obj = _.find(this.skillData, ["skill_id", item.passive_skill_id_1]);
            if (obj) {
                //return _.replace(this.getI18nName(obj, "description"), new RegExp("\\\\n", "g"), " ");
                return _.replace(obj.description, new RegExp("\\\\n", "g"), " ");
            } else {
                return "--";
            }
        },
        debounceInput: _.debounce(function(e) {
            this.filter = e.target.value;
        }, 500),
    },
    computed: {
        exEqUnitList: function() {
            var self = this;
            let unitList = this.unitExEquipmentSlot;
            let filterType = self.filterType;
            unitList = _.filter(unitList, function(obj) {
                var unit = _.find(self.$store.getters.getUnitData, ["unit_id", obj.unit_id]);
                obj["unit_name"] = unit ? unit.unit_name : "";
                obj["search_area_width"] = unit ? unit.search_area_width : "900";                
                return obj.slot_category_1 == filterType || obj.slot_category_2 == filterType || obj.slot_category_3 == filterType;
            });
            unitList = _.orderBy(unitList, ["search_area_width", "asc"]);
            return unitList;
        },
        filterData: function() {
            var self = this;
            let exList = this.exEquipmentData;
            exList = _.filter(exList, function(o) {
                return o.category == self.filterType;
            });
            exList.sort(function(a, b) {
                var dCount = b.clan_battle_equip_flag - a.clan_battle_equip_flag;
                if (dCount) return dCount;
                return Number(b.ex_equipment_id) - Number(a.ex_equipment_id);
            });
            return exList;
        },
        categoryList: function() {
            return this.exEquipmentCategory;
        },
        locale() {
            return this.$i18n.locale;
        },
    },
    created: function() {
        var self = this;
        var exEquipmentCategory = JSON.parse(self.atou(ex_equipment_category));
        var exEquipmentData = JSON.parse(self.atou(ex_equipment_data));
        var skillData = JSON.parse(self.atou(skill_data));
        var unitExEquipmentSlot = JSON.parse(self.atou(unit_ex_equipment_slot));

        this.exEquipmentData = exEquipmentData;
        this.exEquipmentCategory = exEquipmentCategory;
        this.skillData = skillData;
        this.unitExEquipmentSlot = unitExEquipmentSlot;
    },
    mounted: function() {
        var self = this;
        $(".btnFilter").on("click", function() {
            $(this)
                .siblings()
                .removeClass("primary");
            $(this).addClass("primary");
        });
        $(".pcbtn.danger").on("click", function() {
            $(".pcbtn").removeClass("primary");
        });
    },
};
</script>
<style scoped>
table {
    table-layout: fixed;
}

.search-btn {
    border-radius: 15px;
    border: 2px solid #fbd173;
}

.pcbtn {
    min-width: 60px;
}
.pcbtn.active {
	border: 1px solid #f6639b;
}
</style>
